import {useQuery} from "@tanstack/react-query";
import * as api from "../../api";


export const useModel23RegistryQuery = () => {
    return useQuery({
        queryKey: ['registry', 'model23'],
        queryFn: () => api.Registry.getModel23Registry(),
        keepPreviousData: true,
        staleTime: 1000 * 60 * 60 * 24 * 7, // 1 week
    });
}